import { PersonBlock, H6 } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PersonLink } from '../../app/Links'

function GroupReservationPersons({ showHiddenDetails, outerPersonIdGroup, personIdGroup, personData }) {
  const { t } = useTranslation()
  if (personIdGroup === null || personData === null) {
    return null
  }
  let personCurrent
  let personOriginal
  let spouse1Current
  let spouse2Current
  let spouse1Original
  let spouse2Original
  let childCurrent
  let childOriginal
  let parent1Current
  let parent2Current
  let parent1Original
  let parent2Original
  let reservationPersons = null
  switch (outerPersonIdGroup.type) {
    case 'INDIVIDUAL':
      personCurrent = personData[outerPersonIdGroup.group.personId]
      personOriginal = personData[personIdGroup.group.personId]
      reservationPersons = (
        <ReservationPerson
          showHiddenDetails={showHiddenDetails}
          gender={personCurrent.gender}
          name={personCurrent.name}
          personId={personCurrent.personId}
          originalId={personOriginal.personId}
        />
      )
      break
    case 'COUPLE':
      spouse1Current = personData[outerPersonIdGroup.group.spouse1Id]
      spouse2Current = personData[outerPersonIdGroup.group.spouse2Id]
      spouse1Original = personData[personIdGroup.group.spouse1Id]
      spouse2Original = personData[personIdGroup.group.spouse2Id]
      reservationPersons = (
        <>
          <ReservationPerson
            showHiddenDetails={showHiddenDetails}
            gender={spouse1Current.gender}
            name={spouse1Current.name}
            personId={spouse1Current.personId}
            originalId={spouse1Original.personId}
          />
          <H6>{t('spouse', 'Spouse')}</H6>
          <ReservationPerson
            showHiddenDetails={showHiddenDetails}
            gender={spouse2Current.gender}
            name={spouse2Current.name}
            personId={spouse2Original.personId}
            originalId={spouse2Original.personId}
          />
        </>
      )
      break
    case 'SEALING_TO_PARENTS':
      childCurrent = personData[outerPersonIdGroup.group.childId]
      childOriginal = personData[personIdGroup.group.childId]
      parent1Current = personData[outerPersonIdGroup.group.parent1Id]
      parent2Current = personData[outerPersonIdGroup.group.parent2Id]
      parent1Original = personData[personIdGroup.group.parent1Id]
      parent2Original = personData[personIdGroup.group.parent2Id]
      reservationPersons = (
        <>
          <ReservationPerson
            showHiddenDetails={showHiddenDetails}
            gender={childCurrent.gender}
            name={childCurrent.name}
            personId={childCurrent.personId}
            originalId={childOriginal.personId}
          />
          <H6>{t('parents', 'Parents')}</H6>
          <ReservationPerson
            showHiddenDetails={showHiddenDetails}
            gender={parent1Current.gender}
            name={parent1Current.name}
            personId={parent1Current.personId}
            originalId={parent1Original.personId}
          />
          <ReservationPerson
            showHiddenDetails={showHiddenDetails}
            gender={parent2Current.gender}
            name={parent2Current.name}
            personId={parent2Current.personId}
            originalId={parent2Original.personId}
          />
        </>
      )
      break
    default:
  }
  return reservationPersons
}

function ReservationPerson({ showHiddenDetails, gender, name, personId, originalId }) {
  const { t } = useTranslation()
  let details = <PersonLink personId={personId} />
  if (showHiddenDetails) {
    details = (
      <span>
        {t('current', 'Current')}: <PersonLink personId={personId} />
        <br />
        {t('original', 'Original')}: <PersonLink personId={originalId} />
      </span>
    )
  }
  return (
    <div>
      <PersonBlock
        size="sm"
        avatarProps={{
          sex: gender.toLowerCase(),
        }}
        name={name}
        details={details}
      />
    </div>
  )
}

export default GroupReservationPersons
